import { RegvarModel } from './index';
export class RegvarDatetimeModel extends RegvarModel {
}
